import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import api from "@/lib/api";
import { Download, File } from "lucide-react";

const CATEGORIES = [
  ["", "All"],
  ["membership", "Membership"],
  ["affiliation", "Affiliation"],
  ["rulebook", "Rulebook"],
  ["examination", "Examination"],
  ["technical", "Technical"],
  ["brochure", "Brochure"],
];

export default function Downloads() {
  const [cat, setCat] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/downloads", { params: { category: cat || undefined } }).then((r) => setItems(r.data));
  }, [cat]);

  return (
    <div data-testid="downloads-page">
      <PageHero eyebrow="Download Center" title="Official Documents & Forms" subtitle="All federation forms, rulebooks, syllabi and circulars in one place." />
      <section className="section-spacing nkf-container">
        <div className="flex flex-wrap gap-2 mb-6">
          {CATEGORIES.map(([k, l]) => (
            <button key={k || "all"} onClick={() => setCat(k)} data-testid={`dl-cat-${k || "all"}`}
              className={`px-3 py-1.5 text-[11px] uppercase tracking-widest rounded-full border ${cat === k ? "bg-nkf-blue text-white border-nkf-blue" : "bg-white border-slate-200 text-slate-700 hover:border-nkf-blue/40"}`}>{l}</button>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {items.map((d) => (
            <a key={d.id} href={d.file_url} target="_blank" rel="noreferrer" className="federation-card flex items-center justify-between gap-4 p-4 bg-white border border-slate-200 rounded-md">
              <div className="flex items-center gap-3 min-w-0">
                <div className="h-11 w-11 rounded-md bg-nkf-blue/5 border border-nkf-blue/15 flex items-center justify-center"><File className="h-5 w-5 text-nkf-blue" /></div>
                <div className="min-w-0">
                  <div className="font-semibold text-nkf-blue truncate">{d.title}</div>
                  <div className="text-[11px] uppercase tracking-widest text-slate-500">{d.category} · {d.size_kb || "—"} KB</div>
                </div>
              </div>
              <Download className="h-5 w-5 text-nkf-red" />
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
